/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';

import { usePagination, DOTS } from '../hooks/usePagination';

const Pagination = ({ pageSize, currentPage, onPageChange, siblingCount = 1, totalCount }) => {
  const paginationRange = usePagination({ currentPage, totalCount, siblingCount, pageSize });
  const lastPage = paginationRange[paginationRange.length - 1];

  if (currentPage === 0 || paginationRange.length < 2) return null;

  const onPrevPage = () => {
    if (currentPage - 1 < 1) return;
    onPageChange(currentPage - 1);
  };

  const onNextPage = () => {
    if (currentPage + 1 > lastPage) return;
    onPageChange(currentPage + 1);
  };

  const onDotsClick = dotPosition => {
    const nextPage = paginationRange[dotPosition - 1] + 1;
    onPageChange(nextPage);
  };

  return (
    <nav aria-label="Page navigation example">
      <ul className="pagination">
        <li className={`page-item ${currentPage - 1 < 1 && 'disabled'}`} onClick={onPrevPage}>
          <div className="page-link" aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
            <span className="sr-only">Previous</span>
          </div>
        </li>
        {paginationRange.map((pageNumber, index) => {
          if (pageNumber === DOTS)
            return (
              <li key={`dots-${pageNumber + index}`} className={'page-item'} onClick={() => onDotsClick(index)}>
                <button className="page-link">{DOTS}</button>
              </li>
            );
          return (
            <li
              key={`page-number-${pageNumber}`}
              className={`page-item ${pageNumber === currentPage && 'active'}`}
              onClick={() => onPageChange(pageNumber)}
            >
              <button className="page-link">{pageNumber}</button>
            </li>
          );
        })}
        <li className={`page-item ${currentPage + 1 > lastPage && 'disabled'}`} onClick={onNextPage}>
          <div className="page-link" aria-label="Next">
            <span aria-hidden="true">&raquo;</span>
            <span className="sr-only">Next</span>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
